module.exports = __webpack_public_path__ + "static/1-b568f81c594099740c50167798c5dfc9.png";